/* eslint-disable */
// @ts-nocheck

import { useContext } from 'react'

import TextArea from '../../../../../components/forms/TextArea'
import Button from '../../../../../components/misc/Button'
import { DispatchContext } from './DispatchWizard'

interface NotesFinishStepInterface {
  loading: boolean
}

const NotesFinishStep = ({ loading }: NotesFinishStepInterface) => {
  const { control, setCurrentStep } = useContext(DispatchContext)

  return (
    <>
      <div className="flex h-96">
        <div className="col-span-5 w-full overflow-y-auto rounded-md border border-slate-300 p-3 scrollbar-thin">
          <TextArea
            control={control}
            label="Agregue una nota"
            name="observations"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 py-2">
        <Button
          action={() => setCurrentStep!(1)}
          color="gray-900"
          full
          name="Atrás"
          outline
          textColor="slate-700"
        />
        <Button
          color="slate-600"
          full
          loading={loading ?? false}
          name="Finalizar"
          type="submit"
        />
      </div>
    </>
  )
}

export default NotesFinishStep
